<template>
  <div style="width: 100%;">
    <div class="tdesk-sub-header" style="margin-bottom: 9px">
      <h2 class="heading-2">
        {{ order.participants.length }} of {{ order.placesRequired }}
      </h2>

      <div v-if="clientCommenced" class="btn-group tdesk-primary-dropdown-button">
        <button type="button" class="tdesk-primary-button btn" :disabled="capacityReached">
          <i class="fas fa-plus-circle" />
          Add a participant
        </button>

        <button
          id="add-student-dropdown"
          type="button"
          class="btn dropdown-toggle tdesk-primary-button dropdown-toggle-split "
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          :disabled="capacityReached"
        >
          <i class="fas fa-angle-down" />
        </button>

        <ul class="dropdown-menu dropdown-menu-right tdesk-action-dropdown-menu">
          <li class="tdesk-actions-tab">
            <button
              id="add-participant"
              :disabled="capacityReached"
              @click="loadAddParticipantModal()"
            >
              New employee
            </button>
          </li>

          <li class="tdesk-actions-tab">
            <form
              class="button_to"
              method="get"
              :action="searchEmployeesPath"
              data-remote="true"
            >
              <button target="" type="submit">
                Search Employees
              </button>
            </form>
          </li>
        </ul>
      </div>

      <button
        v-else
        id="add-participant"
        :disabled="capacityReached"
        class="tdesk-primary-button"
        style=""
        @click="loadAddParticipantModal()"
      >
        <i class="fas fa-plus-circle" />
        Add a participant
      </button>
    </div>
    <div v-if="order.participants.length > 0">
      <div
        v-for="participant in orderedParticipants"
        :key="participant.id"
        class="tdesk-container participant"
        style="margin-bottom: 7px;"
      >
        <div
          style="display: flex; justify-content: space-between; align-items: center;"
        >
          <div style="display: flex; flex-direction: column;">
            <p
              style="margin: 0 0 3px;"
              class="tdesk-paragraph-small tdesk-neutral-offblack"
            >
              {{ participant.first_name }} {{ participant.last_name ? participant.last_name : '' }}
            </p>
            <p
              style="margin: 0 0 3px;"
              class="tdesk-paragraph-small tdesk-neutral-medium"
            >
              {{ participant.email }}
            </p>
            <p
              style="margin: 0 0 3px;"
              class="tdesk-paragraph-small tdesk-neutral-medium"
            >
              {{ participant.mobile_phone }}
            </p>
          </div>
          <div>
            <div
              v-if="participant.locked"
              class="tdesk-utility-button disabled"
              style="border-color: transparent !important; background: transparent !important;"
            >
              <i class="fas fa-lock tdesk-neutral-dark" />
            </div>
            <div v-else style="display: inline-flex;">
              <div
                class="tdesk-utility-button edit"
                style="margin-right: 7px;"
                @click="editParticipant(participant)"
              >
                <i class="fas fa-pencil-alt" />
              </div>
              <div
                class="tdesk-utility-button delete"
                @click="removeParticipant(participant)"
              >
                <i class="fas fa-trash" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="tdesk-no-search-results-placeholder">
        <i class="fas fa-user-plus" />
        <h3>No participants yet</h3>
      </div>
    </div>
    <div
      style="display: flex; justify-content: flex-end; margin-bottom: 26px; margin-top: 13px"
    >
      <div
        :data-title="tooltipText"
        data-placement="top"
        tabindex="0"
        style="position: relative; display: inline-block;"
        data-toggle="tooltip"
        class="tdesk-tooltip"
      >
        <div
          v-if="!canProceed"
          style="position:absolute;height: 100%;width:100%; cursor:not-allowed"
        />
        <button
          class="tdesk-secondary-button pull-right"
          :disabled="!canProceed"
          @click="proceed()"
        >
          <i class="fas fa-caret-right" />
          Next
        </button>
      </div>
    </div>

    <div id="modal-container" />
  </div>
</template>

<script>
  export default {
    props: {
      clientCommenced: {
        required: true,
        type: Boolean,
      },
      order: {
        required: true,
        type: Object,
      },
    },
    data() {
      return {
        unsortedParticipants: this.order.participants,
      };
    },
    computed: {
      capacityReached() {
        return this.order.participants.length >= this.order.placesRequired;
      },
      orderedParticipants() {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.unsortedParticipants.sort(function (a, b) {
          return a.id - b.id;
        });

        return this.unsortedParticipants;
      },
      canProceed() {
        return this.order.participants.length > 0;
      },
      tooltipText() {
        if (this.canProceed) {
          return;
        }
        return 'You must add at least 1 participant';
      },
      searchEmployeesPath() {
        return Routes.areas_partner_public_course_participants_path({
          cid: this.order.course.id,
          create_path: Routes.areas_partner_public_course_participants_path({ cid: this.order.course.id }),
        });
      },
    },
    mounted() {
      this.$emit('change-page-title', 'Participants');

      const EventBus = window.SSBC?.EventBus;

      if (EventBus) {
        EventBus.$on('add-participant-advanced-search', (event) => {
          const { payload } = event;
          const existingParticipant = this.order.participants.find(participant => participant.email === payload.email);
          const oneLastParticipant = (this.order.placesRequired - this.order.participants.length) <= 1;

          if (existingParticipant) {
            return;
          }

          this.$emit('add-participant', payload);

          if (oneLastParticipant) {
            // Close modal since there's no more seat
            $('#advanced-student-search').modal('hide');
          }
        });
      }
    },
    methods: {
      loadAddParticipantModal() {
        if (this.capacityReached) {
          return;
        }
        this.$emit('show-modal', 'AddParticipantModal');
      },
      proceed() {
        if (this.order.participants.length < 1) {
          return;
        }
        if (!this.capacityReached) {
          var response = confirm('You have added less participants than requested. Are you sure you would like to proceed?');
          if (!response) {
            return;
          }
        }
        this.$emit('proceed');
      },
      editParticipant(participant) {
        this.$emit('change-active-participant', participant);
        this.$nextTick(() => this.$emit('show-modal', 'EditParticipantModal'));
      },
      removeParticipant(participant) {
        var response = confirm('Are you sure you would like to remove this participant?');
        if (response) {
          this.$emit('remove-participant', participant);
        }
      },
    },
  };
</script>
